import { useTranslation } from 'react-i18next';
import { MockAppFrame } from '../mock-app-frame.jsx';
import { MockPhoneFrame } from '../mock-phone-frame.jsx';
import { CurrenciesCard } from '../currencies-card.jsx';
import { AviosCard } from '../avios-card.jsx';

/**
 * Currencies use-case mockup: the currency list and the Avios wallet shown
 * as a full mobile screen beside the status-miles note.
 * @returns {JSX.Element}
 */
export function CurrenciesScreen() {
	const { t } = useTranslation();
	return (
		<>
			<MockAppFrame>
				<CurrenciesCard />
			</MockAppFrame>
			<div className="mock-row">
				<MockPhoneFrame>
					<AviosCard />
				</MockPhoneFrame>
				<div className="use-case-callout card">
					<h3>{t('usecase.currencies.avios.title')}</h3>
					<p>{t('usecase.currencies.avios.body')}</p>
					<h3>{t('usecase.currencies.status.title')}</h3>
					<p>{t('usecase.currencies.status.body')}</p>
				</div>
			</div>
		</>
	);
}
